import React from 'react';
import type { ReactElement } from 'react';

import '@philips-internal/oswald-ui-components';
import '@philips-internal/pending-approval-components';
import { Foundation } from '@philips-internal/oswald-ui-foundation';
import { createRoot } from 'react-dom/client';
import type { Root as ReactRoot } from 'react-dom/client';

import { bootstrap } from './configuration';

import './controllers';

function Root(): ReactElement {
  return (
    <Foundation
      bootstrap={bootstrap}
      root={{
        fragmentName: 'root',
      }}
    />
  );
}

declare global {
  interface Window {
    reactRoot: ReactRoot | undefined;
  }
}

if (!window.reactRoot) {
  const container = document.getElementById('root');
  if (container) {
    window.reactRoot = createRoot(container);
    window.reactRoot.render(<Root />);
  }
}
